import React, { useContext, useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import Image from '../common/image';
import Icon4 from "../../assest/images/Icon4.png";
import Icon3 from "../../assest/images/Icon3.png";
import Icon9 from '../../assest/images/Icon9.png';
import config from "../../envconfig";
import CustomDropdown from '../common/CustomDropdown';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { UserContext } from '../common/UserContext';

const RMList = () => {
  const [routeList, setRouteList] = useState([]);
  const [message, setMessage] = useState('');
  const [selectedSCP, setSelectedSCP] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [suspendConfirmationModal, setSuspendConfirmationModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedRouteId, setSelectedRouteId] = useState(null);
  const [selectedRouteName, setSelectedRouteName] = useState(null); // Define selectedRouteId state
  const [inputValue, setInputValue] = useState(''); // Define selectedRouteId state
  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
  const [showAsterisks, setShowAsterisks] = useState({});
  const [selectedStatus, setSelectedStatus] = useState('');
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Number of items per page
  const [isSuspending, setIsSuspending] = useState(false);
  // Get current items
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = routeList.slice(indexOfFirstItem, indexOfLastItem);
  const toastRef = useRef(null);
  const showToast = (type, message, options = {}) => {
    if (toastRef.current && toast.isActive(toastRef.current)) {
      toast.update(toastRef.current, {
        render: message,
        type,
        autoClose: 3000,
        ...options,
      });
    } else {
      toastRef.current = toast[type](message, {
        autoClose: 3000,
        ...options,
      });
    }
  };

  useEffect(() => {
    sessionStorage.setItem('UM_GroupId', UM_GroupId);
    sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
    sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
    sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
    sessionStorage.setItem('UM_UserId', UM_UserId);
    sessionStorage.setItem('UM_UserCode', UM_UserCode);

    sessionStorage.setItem('selectedScpId', selectedScpId);

  }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);



  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getRouteList = async () => {
    logAction('getRouteList():started');
    try {
      const response = await fetch(`${config.API_URL}/RouteMasterList/${selectedScpId}`, {
        method: 'GET',
      });

      if (response.ok) {
        const data = await response.json();

        setRouteList(data.routeList || []);
      } else {
        const errorMessage = await response.text();
        console.error('Error fetching route list:', errorMessage);
        setMessage('Error fetching route list');
        logAction('getRouteList():Error fetching route list', true);
      }
    } catch (error) {
      console.error('Failed to fetch route list:', error);
      setMessage('Failed to fetch route list');
      logAction('getRouteList():Failed to fetch route list', true);
    } finally {
      logAction('getRouteList():ended');
    }
  };

  useEffect(() => {
    logAction(`getRouteList():Routemaster List page accessed`);
    getRouteList();
  }, [selectedScpId, UM_UserCode]);

  const handleCloseModal = () => {
    logAction('handleCloseModal():started');
    setShowModal(false);
    setInputValue('');
    setShowAsterisks({});
    setSuspendConfirmationModal(false);
    logAction('handleCloseModal():Pop Up screen closed');
    logAction('handleCloseModal():ended');
  };

  const handleShowModal = (routeId, isSuspendModal, routeName) => {
    logAction('handleShowModal():started');
    setSelectedRouteId(routeId);
    setSelectedRouteName(routeName);
    if (isSuspendModal) {
      setSuspendConfirmationModal(true);
    } else {
      setShowModal(true);
    }
    logAction(`handleShowModal():Opened ${isSuspendModal ? 'Suspend' : 'SCP Names'} Pop Up Screen for Route ${routeId}`);
    logAction('handleShowModal():ended');
  };

  const logAudit = async (module, message, oldValue = "", newValue = "") => {
    const auditLogPayload = {
      AUTR_ScreenName: module, // Name of the screen or module
      AUTR_OldValue: oldValue, // Old value if applicable, else empty
      AUTR_NewValue: newValue, // New value if applicable, else empty
      AUTR_Message: message,
      AUTR_UserID: UM_UserId,
      AUTR_UserName: UM_UserCode,
      AUTR_AuditType: 13,
      AUTR_SCPID: selectedScpId,
      AUTR_CompanyGrpId: UM_CompanyGrpID,
      AUTR_CompanyID: UM_CompanyID,
      AUTR_CreatedBy: UM_UserId
    };

    try {
      const response = await fetch(`${config.API_URL}/audit/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(auditLogPayload),
      });

      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  const handleConfirmSuspend = async () => {

    // 🚫 Prevent button spam
    if (isSuspending) return;

    const asterisks = {};
    if (inputValue.trim() === '') {
      asterisks.remarks = true;
      setShowAsterisks(asterisks);
      return;
    }

    setIsSuspending(true); // 🔒 Lock button

    logAction('handleConfirmSuspend():started');

    try {
      logAction(`handleConfirmSuspend():Checking active user count for Route ${selectedRouteId} (${getRouteName(selectedRouteId)})`);

      const responseCount = await fetch(`${config.API_URL}/routestatus/${selectedRouteId}`);

      if (responseCount.ok) {
        const { activeUserCount, activeSchemeCount } = await responseCount.json();

        if (activeUserCount === 0 && activeSchemeCount === 0) {

          logAction(`handleConfirmSuspend():Confirmed Suspension of Route ${selectedRouteId} (${getRouteName(selectedRouteId)})`);

          const responseSuspend = await fetch(
            `${config.API_URL}/routing_master/suspend/${selectedRouteId}`,
            {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ inputValue }),
            }
          );

          if (responseSuspend.ok) {
            toast.success(`Route : ${selectedRouteName} suspended successfully.`);

            const transactionDetails = [
              { AUTRN_OldValue: "-", AUTRN_NewValue: `Suspend`, AUTRN_ParamererName: "Status" },
            ];

            logAudit(
              "Route Master",
              `Route ${selectedRouteName} suspended successfully`,
              '-',
              `-`,
              false,
              transactionDetails
            );

            getRouteList();

          } else {
            const errorMessage = await responseSuspend.text();
            console.error('Error suspending route:', errorMessage);
            setMessage('Error suspending route. Please try again.');
            logAction(
              `handleConfirmSuspend():Error suspending route: ${errorMessage} for ${selectedRouteId} (${getRouteName(selectedRouteId)})`,
              true
            );
          }

        } else {

          if (activeUserCount !== 0) {
            showToast('error', `You cannot suspend the Route : ${selectedRouteName} because a reference exists in the Shipment Master.`);
          } else {
            showToast('error', `You cannot suspend the Route : ${selectedRouteName} because a reference exists in the Scheme Master.`);
          }

          logAction(
            `handleConfirmSuspend():Cannot suspend Route ${selectedRouteId} (${getRouteName(selectedRouteId)}) with active users (${activeUserCount})`,
            true
          );
        }

      } else {
        const errorMessage = await responseCount.text();
        console.error('Error fetching active user count:', errorMessage);
        setMessage('Error checking active user count. Please try again.');
        logAction(
          `handleConfirmSuspend():Error checking active user count: ${errorMessage} for ${selectedRouteId} (${getRouteName(selectedRouteId)})`,
          true
        );
      }

    } catch (error) {
      console.error('Network error:', error);
      setMessage('Failed to suspend route');
      logAction(
        `handleConfirmSuspend():Failed to suspend route ${selectedRouteId} (${getRouteName(selectedRouteId)})`,
        true
      );
    } finally {
      setIsSuspending(false); // 🔓 Unlock button
      setSuspendConfirmationModal(false);
      setInputValue('');
      logAction(`handleConfirmSuspend():ended`);
    }
  };

  const handleShowSCPName = async (RUTL_ID) => {
    logAction('handleShowSCPName():started');
    try {
      const response = await fetch(`${config.API_URL}/routing_master/pool/${RUTL_ID}`, {
        method: 'GET',
      });

      if (response.ok) {
        const data = await response.json();
        const scpNames = data.scpNames || [];
        setSelectedSCP(scpNames.join(', '));
        handleShowModal(null, false);
      } else {
        const errorMessage = await response.text();
        console.error('Error fetching SCP Names:', errorMessage);
        setMessage('Error fetching SCP Names');
        logAction(`handleShowSCPName():Error fetching SCP Names for Pool button pop up screen: ${errorMessage}`, true);
      }
    } catch (error) {
      console.error('Failed to fetch SCP Names:', error);
      setMessage('Failed to fetch SCP Names');
      logAction('handleShowSCPName():Failed to fetch SCP Names for Pool button pop up screen', true);
    } finally {
      logAction(`handleShowSCPName():Clicked Pool button for Route ${getRouteName(RUTL_ID)} and SCP Names shown for it in Pop Up screen`);
      logAudit("Routing Master List", `SCP Names shown for Route Name ${getRouteName(RUTL_ID)}`, '-', `-`);
      logAction('handleShowSCPName():ended');
    }
  };

  const handleSuspend = (routeId, routeName) => {
    logAction('handleSuspend():started');
    logAction(`handleSuspend():Initiated Suspension of Route ${routeId} (${getRouteName(routeId)})`);
    handleShowModal(routeId, true, routeName);
    logAction('handleSuspend():ended');
  };

  const handleSearchChange = async (event) => {
    logAction('handleSearchChange():started');
    const searchValue = event.target.value;
    setSearchTerm(searchValue);
    logAction(`handleSearchChange():searching ${searchValue}`);
    setCurrentPage(1); // Reset to first page when searching
    filterRoutes(searchValue, selectedStatus);
    logAction('handleSearchChange():ended');
  };

  const handleStatusChange = (event) => {
    logAction('handleStatusChange():started');
    const statusValue = event.target.value;
    setSelectedStatus(statusValue);
    logAction(`handleStatusChange():filtering ${statusValue}`);
    setCurrentPage(1); // Reset to first page when filtering
    filterRoutes(searchTerm, statusValue);
    logAction('handleStatusChange():ended');
  };

  const filterRoutes = async (searchValue, statusValue) => {
    try {
      const response = await fetch(`${config.API_URL}/RouteMasterList/${selectedScpId}`, {
        method: 'GET',
      });

      if (response.ok) {
        const data = await response.json();
        let filteredRouteList = data.routeList;

        if (searchValue) {
          filteredRouteList = filteredRouteList.filter(route =>
            route.RUTL_Name.toLowerCase().includes(searchValue.toLowerCase())
          );
        }

        console.log("Status:", statusValue);

        if (statusValue) {
          filteredRouteList = filteredRouteList.filter(route =>
            route.RUTL_Status === parseInt(statusValue)
          );
        }
        setRouteList(filteredRouteList);
      } else {
        const errorMessage = await response.text();
        console.error('Error fetching route list:', errorMessage);
        setMessage('Error fetching route list');
        logAction(`filterRoutes():Error fetching route list: ${errorMessage}`, true);
      }
    } catch (error) {
      console.error('Failed to fetch route list:', error);
      setMessage('Failed to fetch route list');
      logAction('filterRoutes():Failed to fetch route list', true);
    } finally {
      logAction('filterRoutes():Performed Filter');
      logAction('filterRoutes():ended');
    }
  };

  const logAction = (action, isError = false) => {

    const logData = {
      module: "Route-Master:",
      action: action,
      userCode: UM_UserCode,

      isError: isError,
    };

    fetch(`${config.API_URL}/api/log`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(logData),
    })
      .then(response => response.json())
      .then(data => {
        console.log('Log response:', data);
      })
      .catch(error => {
        console.error('Error logging action:', error);
      })

  };

  const getRouteName = (routeId) => {
    const route = routeList.find(route => route.RUTL_ID === routeId);
    return route ? route.RUTL_Name : 'Unknown Route';
  };


  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);

    // Remove asterisk as soon as user types something valid
    if (value.trim() !== '') {
      setShowAsterisks(prev => ({
        ...prev,
        remarks: false
      }));
    }
  };

  return (
    <>

      <ToastContainer style={{
        marginTop: '73px',
        fontSize: '14px',
        width: '40%',
      }} />

      <div className='main_container'>

        <h1 className='formHeading'>Route Master
        </h1>
        <p>{message}</p>
        <div className="filter-container">
          <div className='select-container_list'>
            <select
              className='select-box_list'
              disabled
            >
              <option value="RouteName">Route Name</option>
            </select>

            {/* <div className='icon-container'>
              {isSelectOpen === 'scpName' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
            </div> */}
          </div>

          <input
            type="text"
            placeholder="Search"
            className='search-input searchbar'
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <div className='select-container_list'>

            <CustomDropdown
              options={[
                { value: 1, label: 'Active' },
                { value: 2, label: 'Inactive' },
                { value: 3, label: 'Suspend' }
              ]}
              value={selectedStatus}
              onChange={handleStatusChange}
              name="statusFilter"
              placeholder="--Select Status--"
              idKey="value"
              displayKey="label"
            />

          </div>
        </div>

        <table className='tableClass'>
          <thead>
            <tr
            >
              <th
              >Sr. No.</th>
              <th
              >Route Name</th>
              <th
              >SCP Name</th>
              <th
              >Status</th>
              <th
              >Action</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length === 0 ? ( // Check if there are no current items
              <tr>
                <td colSpan="4">No Records Found</td>
              </tr>
            ) : (
              currentItems.map((route, index) => (
                <tr key={index} className='table-content'>
                  <td>{index + 1 + indexOfFirstItem}</td>
                  <td>{route.RUTL_Name}</td>
                  <td>{route.RUTL_Status === 3 ? (
                    <span>-</span>
                  ) : (
                    <>

                      <Link
                        onClick={() => handleShowSCPName(route.RUTL_ID,)}
                        title='Details'
                      >
                        <Image src={Icon9} alt="pool" className="poolimage" />
                      </Link>
                    </>
                  )}</td>
                  <td>{route.RUTL_Status === 1 && 'Active'}
                    {route.RUTL_Status === 2 && 'Inactive'}
                    {route.RUTL_Status === 3 && 'Suspend'}</td>
                  <td style={{ paddingLeft: "14.5px" }}>
                    {route.RUTL_Status === 3 ? (
                      <span style={{ marginLeft: "-10px" }}>-</span>
                    ) : (
                      <>
                        <Link
                          to={`/rmedit/${route.RUTL_ID}`}
                          title="Edit"
                        >
                          <Image
                            src={Icon3}
                            alt="pencil"
                            className="editicon"
                            width={25}
                          />
                        </Link>

                        <img
                          src={Icon4}
                          alt="suspendremovebg"
                          className="suspendicon"
                          title="Suspend"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleSuspend(route.RUTL_ID, route.RUTL_Name)
                          }
                        />
                      </>
                    )}
                  </td>
                </tr>
              )))}
          </tbody>
        </table>

        <ul className="pagination">
          {/* First Page Button */}
          <li className={currentPage === 1 || routeList.length === 0 ? "page-item disabled" : "page-item"}>
            <button className="page-linkd" onClick={() => paginate(1)}>First</button>
          </li>

          {/* Previous Page Button */}
          <li className={currentPage === 1 || routeList.length === 0 ? "page-item disabled" : "page-item"}>
            <button className="page-linkd" onClick={() => paginate(currentPage - 1)}>Previous</button>
          </li>

          {/* Page Numbers */}
          {Array.from({ length: Math.ceil(routeList.length / itemsPerPage) }, (_, index) => (
            <li key={index} className={currentPage === index + 1 ? "page-item active" : "page-item"}>
              <button className="page-linkd" onClick={() => paginate(index + 1)}>{index + 1}</button>
            </li>
          ))}

          {/* Next Page Button */}
          <li className={currentPage === Math.ceil(routeList.length / itemsPerPage) || routeList.length === 0 ? "page-item disabled" : "page-item"}>
            <button className="page-linkd" onClick={() => paginate(currentPage + 1)}>Next</button>
          </li>

          {/* Last Page Button */}
          <li className={currentPage === Math.ceil(routeList.length / itemsPerPage) || routeList.length === 0 ? "page-item disabled" : "page-item"}>
            <button className="page-linkd" onClick={() => paginate(Math.ceil(routeList.length / itemsPerPage))}>Last</button>
          </li>
        </ul>

        {/* </div> */}
      </div>
      <Link to={`/dashboard/rm`}>
        <button type="button" className="back_btn">
          BACK
        </button>
      </Link>

      <Modal show={showModal} backdrop="static" onHide={handleCloseModal} className="modal-container" style={{ backdropFilter: 'blur(3px)', backgroundColor: 'rgba(0, 0, 0, 0.3)' }} centered>
        <Modal.Header closeButton className="">
          <Modal.Title style={{
            color: "#465a64",
            fontSize: '20PX',
            fontWeight: "bold"
          }}>SCP Name List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="table-responsive"> */}
          <table className="tableClass" style={{ width: "100%" }}>
            <thead className="bg-light">
              <tr>
                <th style={{ width: "80px" }}>Sr. No.</th>
                <th>SCP Name</th>
              </tr>
            </thead>
            <tbody>
              {selectedSCP &&
                selectedSCP.split(',').map((scpName, index) => (
                  <tr key={index}>
                    <td style={{ width: "80px" }}>{index + 1}</td>
                    <td>{scpName.trim()}</td>
                  </tr>
                ))}
            </tbody>
          </table>

          {/* </div> */}
        </Modal.Body>
      </Modal>


      {suspendConfirmationModal && (
        <div className="popup_overlay" style={{
          backdropFilter: 'blur(3px)',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
        }}>
          <div className="resetpopup">
            <h1>:: User Confirmation ::</h1>
            <h4>Are you sure you want to suspend this Route : {selectedRouteName} ?</h4>
            <div className='remark_container'>
              <span className='me-3 remark_label'>
                Remark:
                {showAsterisks["remarks"] && <span className="text-danger"> *</span>}
              </span>


              <textarea
                type='text'
                className='remark_text'
                value={inputValue}
                onChange={handleInputChange}
                placeholder="Enter suspend remark"
                style={{
                  border: '1px solid #ced4da',
                  padding: '10px',

                  fontSize: '16px',
                  resize: 'none',  // Keep this if you want to prevent resizing
                  overflow: 'auto',  // Enable scrollbars when content overflows
                  transition: 'height 0.3s',
                  borderRadius: "5px",
                  outline: "none"

                }}
              />
            </div>
            <div className="popup_btn_container">
              <button
                className="yes_btn"
                onClick={handleConfirmSuspend}
                disabled={isSuspending}
                // style={{
                //   opacity: isSuspending ? 0.6 : 1,
                //   cursor: isSuspending ? 'not-allowed' : 'pointer'
                // }}
              >
                YES
              </button>
              <button className="no_btn" onClick={handleCloseModal}>NO</button>
            </div>
          </div>
        </div>
      )}


    </>
  );
};

export default RMList;